export function timePassed (d1: number, d2: number): number {
  if (isNaN(d1) || isNaN(d2)) {
    return 0
  }

  return Math.abs(d2 - d1)
}

export function timestamp() {
  return Date.now();
}
